import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=7d4c1bf5"
import script from "./departments.ts?vue&type=script&lang=ts&external"
export * from "./departments.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports